<template>
  <div class="response-tabs-resume">
    <div v-if="loading"></div>
    <div v-else-if="!error">
      <div class="block">
        <div class="caption">
          <div class="caption-title">
            {{ $tr('responses.resume.questionnaire.personalData') }}
          </div>
          <div class="caption-block-hide" @click="toggleBlock('response-resume-personal-block')">
            <i v-if="personalInfoBlockHidden" class="fa fa-caret-down"></i>
            <i v-else class="fa fa-caret-up"></i>
          </div>
        </div>
        <div class="block-content" v-if="!personalInfoBlockHidden">
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.fullName') }}</div>
            <div>{{ [data.last_name, data.first_name, data.second_name].join(' ') }} </div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.age') }}</div>
            <div>{{ age }}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.citizenship') }}</div>
            <div>{{ data.citizenship}}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.email') }}</div>
            <div>{{ data.email }}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.phone') }}</div>
            <div>{{ data.phone }}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.cv.label') }}</div>
            <div>
              <a v-if="data.cv_link" target="_blank" :href="data.cv_link">
                {{ $tr('responses.resume.questionnaire.cv.view') }}
              </a>
              <span v-else>
                {{ $tr('responses.resume.questionnaire.cv.no') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="block">
        <div class="caption">
          <div class="caption-title">
            {{ $tr('responses.resume.questionnaire.education') }}
          </div>
          <div class="caption-block-hide" @click="toggleBlock('response-resume-education-block')">
            <i v-if="educationBlockHidden" class="fa fa-caret-down"></i>
            <i v-else class="fa fa-caret-up"></i>
          </div>
        </div>
        <div class="block-content" v-if="!educationBlockHidden">

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.university') }}</div>
            <div>{{data.university}}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.speciality') }}</div>
            <div>{{data.speciality}}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.avarageScore') }}</div>
            <div>{{data.average_score}}</div>
          </div>

          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.graduateYear') }}</div>
            <div>{{data.graduation_year}}</div>
          </div>
        </div>
      </div>

      <div class="block block-last block-additional">
        <div class="caption">
          <div class="caption-title">
            {{ $tr('responses.resume.questionnaire.additional') }}
          </div>
          <div class="caption-block-hide" @click="toggleBlock('response-resume-additional-block')">
            <i v-if="additionalInfoBlockHidden" class="fa fa-caret-down"></i>
            <i v-else class="fa fa-caret-up"></i>
          </div>
        </div>
        <div class="block-content" v-if="!additionalInfoBlockHidden">
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.englishLevel') }}</div>
            <div class="gray">{{data.english_level}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.shiftMethodWork') }}</div>
            <div :class="{gray: !data.ready_for_shift_method}">{{yesNoLabel(data.ready_for_shift_method)}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.previousInterview') }}</div>
            <div :class="{gray: !lastInterviewDate}">{{ lastInterviewDate ? lastInterviewDate: yesNoLabel(false) }}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.foreignPassport') }}</div>
            <div :class="{gray: !data.have_international_passport}">{{yesNoLabel(data.have_international_passport)}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.driverLicence') }}</div>
            <div :class="{gray: !data.have_driver_license}">{{yesNoLabel(data.have_driver_license)}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.militaryDuty') }}</div>
            <div :class="{gray: !data.have_military_id}">{{yesNoLabel(data.have_military_id)}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.relativesInShlum') }}</div>
            <div :class="{gray: !data.have_relatives_in_company}">{{yesNoLabel(data.have_relatives_in_company)}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.relativesInNearShlum') }}</div>
            <div :class="{gray: !data.have_relatives_in_clients}">{{yesNoLabel(data.have_relatives_in_clients)}}</div>
          </div>
          <div class="item">
            <div>{{ $tr('responses.resume.questionnaire.relativesInGov') }}</div>
            <div :class="{gray: !data.have_relatives_in_government}">{{yesNoLabel(data.have_relatives_in_government)}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="error" class="error">
      {{ $tr('common.errrorLoadingPageContent') }}
    </div>
  </div>
</template>

<script>

import Moment from 'moment'
import { getAgeInYears } from '@/_helpers/utils.js'

export default {
  name: 'response-tabs-resume',

  props: {
    response: Object
  },

  computed: {
    personalInfoBlockHidden () {
      return this.$store.getters['response/blockHidden']['response-resume-personal-block']
    },

    educationBlockHidden () {
      return this.$store.getters['response/blockHidden']['response-resume-education-block']
    },

    additionalInfoBlockHidden () {
      return this.$store.getters['response/blockHidden']['response-resume-additional-block']
    },

    state () {
      return this.$store.state.process.shlumberger.response.questionnaire
    },

    loading () {
      return this.state.loading
    },

    error () {
      return this.state.error
    },

    data () {
      return this.state.data
    },

    age () {
      if (this.data.birth_date) {
        return getAgeInYears(this.data.birth_date)
      }

      return ''
    },

    lastInterviewDate () {
      if (this.data.already_interviewed) {
        return (new Moment(this.data.last_interview_date)).format('Y.MM.DD')
      }

      return ''
    }
  },

  methods: {
    toggleBlock (blockId) {
      this.$store.dispatch('response/toggleBlock', blockId)
    },

    fetch () {
      this.$store.dispatch('process/shlumberger/response/questionnaire/fetch', this.response)
    },

    yesNoLabel (value) {
      return value ? 'Да' : 'Нет'
    }
  },

  beforeMount () {
    this.fetch()
  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.response-tabs-resume {
  padding-top: 20px;
  padding-left: 12px;
}

.block {
  &:not(.block-last) {
    border-bottom: 1px solid #d7d7d7;
  }
  margin-right: 40px;

  .caption {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    .caption-title {
      font-size: 16px;
      font-weight: bold;
    }
    .caption-block-hide {
      color: $green;
      cursor: pointer;
    }
  }

  .block-content {
    .item {
      padding: 10px 0px;
      display: flex;
      width: 100%;

      div:first-child {
        width: 25%;
        min-width: 25%;
      }
    }
  }

  &.block-additional {
    .block-content {
      .item {
        :first-child {
          width: 80%;
          padding-right: 5px;
        }
        :not(:first-child) {
          color: $green;
        }
        .gray {
          color: $grey-color;
        }
      }
    }
  }
}
</style>
